import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Hero from './components/hero';
import Navbar from './components/navbar';


import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import AboutUs from './components/abutus';
import Services from './components/services';
import Footer from './components/footer';
import ContactSection from './components/contact';
import FaqSection from './components/faq';
import PrivacyPolicy from './components/privacy';
import Impressum from './components/impressum';
import CookieConsent from './components/cookiebanner';


function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.querySelector(location.state.scrollTo);
      if (el) {
        // Delay slightly to allow rendering
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <AboutUs />
      <Services />
      <FaqSection />
      <ContactSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impresszum" element={<Impressum />} />
          <Route path="/adatvedelem" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
